"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyStyles = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
/**
 * Merges component styles from different sources and passes on the the component as 'styles' prop.
 *
 * Following sources are considered as style sources. (In order of least important first):
 *
 * 1. defaultStyles: A component may provide default styles as a "defaultStyles" static
 * property of component. This is similar to defaultProps in react.
 * 2. stylesParam: 3rd property of this function. Note: Component Registry passes 'styles' prop from it's registry item.
 * 3. Themes: From theme.components[componentName] property of current theme.
 * 4. styles prop: The styles prop passed on to the component during usage.
 *
 * @param options
 */
function applyStyles(options) {
    return (Component) => {
        const name = typeof options === 'string' ? options : options.name;
        const ThemedComponent = (props) => {
            // const { styles: stylesProp, ...rest } = props;
            const styles = hooks_1.useStyles(name, props, Component.defaultStyles);
            // If we were able to extract any rules, pass them forward in the styles prop
            const finalProps = Object.keys(styles).length > 0 ? Object.assign(Object.assign({}, props), { styles }) : props;
            return react_1.default.createElement(Component, finalProps);
        };
        ThemedComponent.displayName = 'ThemedComponent';
        return ThemedComponent;
    };
}
exports.applyStyles = applyStyles;
